/*
 * @Author: qian.tang
 * @Date: 2022-12-08 15:36:36
 * @LastEditors: Qian Tang qian@itrazotracetech.com
 * @LastEditTime: 2022-12-21 09:31:43
 * @FilePath: \itrazo-portal-dev\src\utilities\Functions\GlobalHelperFunctions.tsx
 * @Description: Global helper functions
 *
 * Copyright (c) 2022 by Qian Tang qian@itrazotracetech.com, All Rights Reserved.
 */
import React from "react";
import { VALUE_CHAIN_API } from "../AdiApi";
import AWS from "aws-sdk";
import { PutObjectRequest } from "aws-sdk/clients/mediastoredata";
import { Modal } from "antd";
import { ExclamationCircleFilled, WarningFilled } from "@ant-design/icons";
import { DATE_FORMAT, ENCRYPTION_KEY, SESSION_STORAGE_KEYS, STATIC_CUSTOMERS } from "../CONSTANTS";
import CryptoJS from "crypto-js";
import { Country, State, City } from 'country-state-city'
import { SelectorOption, TableFilterOption } from "utilities/types";
import moment from "moment";

const { confirm } = Modal;

// decrypt text data
export const decryptData = (text: string): string => {
  const bytes = CryptoJS.AES.decrypt(text, ENCRYPTION_KEY);
  var res = JSON.parse(JSON.stringify(bytes.toString(CryptoJS.enc.Utf8)));
  // console.log("decripted", res);
  if (res.length > 2 && res[0] === "\"") {
    // get rid of quotes
    res = res.slice(1, res.length - 1)
  }
  return res
};
// encrypt text data
export const encryptData = (text: string): string => {
  const res = CryptoJS.AES.encrypt(
    JSON.stringify(text),
    ENCRYPTION_KEY
  ).toString();
  return res;
}

// encrypt and store data in session storage
// if the value is an object, parameter json needs to be set to true
export const setSessionStorage = (key: string, value: any, json?: boolean) => {
  const encryptedValue = encryptData(json ? JSON.parse(JSON.stringify(value)) : value);
  sessionStorage.setItem(key, encryptedValue);
};

// get data from session storage and decrypt
// if the value is an object, parameter json needs to be set to true
export const getSessionStorage = (key: string, json?: boolean) => {
  const encryptedValue = sessionStorage.getItem(key);
  if (encryptedValue) {
    const decryptedValue = decryptData(encryptedValue);
    return json ? JSON.parse(decryptedValue) : decryptedValue;
  }
  return null;
}

export const setLocalStorage = (key: string, value: any, json?: boolean) => {
  const encryptedValue = encryptData(json ? JSON.parse(JSON.stringify(value)) : value);
  localStorage.setItem(key, encryptedValue);
};

// get data from session storage and decrypt
// if the value is an object, parameter json needs to be set to true
export const getLocalStorage = (key: string, json?: boolean) => {
  const encryptedValue = localStorage.getItem(key);
  if (encryptedValue) {
    const decryptedValue = decryptData(encryptedValue);
    return json ? JSON.parse(decryptedValue) : decryptedValue;
  }
  return null;
}


export const getBizCode = () => {

  const bizCode = getSessionStorage(SESSION_STORAGE_KEYS.BIZ_CODE) || ''
  // console.log('getBizCode', bizCode)
  return bizCode

  // const bizString = getSessionStorage(SESSION_STORAGE_KEYS.BIZ_CODE)
  // console.log('bizString', bizString)
  // if (bizString) {
  //   const bizCode = decryptData(JSON.parse(bizString));
  //   console.log('bizCode', bizCode,)
  //   // TODO: change to upper case is only for ADI one customer, and for demo purpose
  //   // in the future, this part need to be removed
  //   if (bizCode == 'adi') {
  //     console.log(' adi bizCode change to upper', bizCode)
  //     return bizCode.toUpperCase()
  //   }

  //   console.log(' getBizCode', bizCode)

  //   return bizCode
  // }

  // console.log(' no bizCode found!!!')
  // return ''
}

// static method for static customers
// now keep organicoliveoil, costagroup, thechosenone as cusomer_role 
export const getOrganization = (): any => {

  // const access_level = JSON.parse(`${sessionStorage.getItem(SESSION_STORAGE_KEYS.ACCESS_LEVEL)}`);
  const access_level = getSessionStorage(SESSION_STORAGE_KEYS.ACCESS_LEVEL, true);
  console.log('access_level ce module', access_level);

  let organization: any = ''
  if (access_level[STATIC_CUSTOMERS.ORGANICOLIVEOIL]) {
    organization = STATIC_CUSTOMERS.ORGANICOLIVEOIL
  }
  else if (access_level[STATIC_CUSTOMERS.COSTAGROUP]) {
    organization = STATIC_CUSTOMERS.COSTAGROUP
  }
  else if (access_level[STATIC_CUSTOMERS.THECHOSENONES]) {
    organization = STATIC_CUSTOMERS.THECHOSENONES
  }
  else if (access_level[STATIC_CUSTOMERS.OTHER]) {
    organization = STATIC_CUSTOMERS.OTHER
  }
  // statically set organicoliveoil as the default one
  else {
    organization = STATIC_CUSTOMERS.ORGANICOLIVEOIL
  }


  return organization
}

const BIZ_CODE = getBizCode();



export const getIDsPromise = (type: string) => {
  // console.log("getIDsPromise refID, get custodies item=>", type);
  const url = `${type}/${BIZ_CODE}`;
  return new Promise((resolve, reject) => {
    VALUE_CHAIN_API.get(url)
      .then((res: any) => {
        // console.log("get id listaa " + type, res);
        const result = res.data;
        const idL = result.map((item: any) => item.barcode);
        // setIdList(idL);
        return resolve(idL);
      })
      .catch((err) => {
        console.log("ERROR getIDsPromise", err);
        return reject(err);
      });
  });
};
export const getAllIDsPromise = () => {
  // console.log("getALLRefIDsPromise refID, ");

  const promList: any = [];
  const prodIdsList = getIDsPromise("products");
  promList.push(prodIdsList);
  const batchIdsList = getIDsPromise("batches");
  promList.push(batchIdsList);

  return new Promise((resolve, reject) => {
    Promise.all(promList)
      .then((allPromiseRes) => {
        // console.log("idsssss allPromiseRes", allPromiseRes);
        const prodL: any = allPromiseRes[0];
        const batchL: any = allPromiseRes[1];

        const allIDList = [...prodL, ...batchL];

        return resolve(allIDList);
      })
      .catch((err) => {
        console.log("get id all promise err", err);
        return reject(err);
      });
  });
};
export const getRefIDsPromise = () => {
  // console.log("getRefIDsPromise refID,");

  return new Promise((resolve, reject) => {
    const url = `/valuechain/${BIZ_CODE}`;
    VALUE_CHAIN_API.get(url)
      .then((res: any) => {
        // console.log("get the ref id list func", res);
        const result = res.data.body.Items;
        // console.log("get the ref id list func", result);
        return resolve(result);
      })
      .catch((err) => {
        console.log("get id all promise err", err);
        return reject(err);
      });
  });
};

export const getFileNameFromS3Key = (s3Key: string) => {
  let fName = "No File Name";
  if (s3Key.length > 0) {
    const lst = s3Key.split("/");
    fName = lst[lst.length - 1];
  }
  return fName;
};


export function getUploadToS3Promise(
  selectedFile: File,
  key: string,
  handleUploadSuccess?: Function,
  handleUploadFail?: Function
) {

  // const decryptedAccessKeyId = decryptData(JSON.parse(sessionStorage.getItem("AccessKeyId")!))
  // const decryptedAccessKeySec = decryptData(JSON.parse(sessionStorage.getItem("AccessKeySec")!))
  // const decryptedSessionToken = decryptData(JSON.parse(sessionStorage.getItem("sessionToken")!))
  // const decryptedSessionUSER_STORAGE = decryptData(JSON.parse(sessionStorage.getItem("USER_STORAGE")!)) // bucket name

  const decryptedAccessKeyId = getSessionStorage("AccessKeyId")
  const decryptedAccessKeySec = getSessionStorage("AccessKeySec")
  const decryptedSessionToken = getSessionStorage("sessionToken")
  const decryptedSessionUSER_STORAGE = getSessionStorage("USER_STORAGE") // bucket name
  // AWS config
  AWS.config.update({
    accessKeyId: decryptedAccessKeyId,
    secretAccessKey: decryptedAccessKeySec,
    sessionToken: decryptedSessionToken,
  });
  const myBucket = new AWS.S3({
    params: { Bucket: decryptedSessionUSER_STORAGE },
    region: "ap-southeast-2",
  });
  const params: AWS.S3.PutObjectRequest = {
    ACL: "bucket-owner-full-control",
    Body: selectedFile,
    Bucket: decryptedSessionUSER_STORAGE, // replace with session storage current user s3 bucket
    Key: key,
    ContentType: selectedFile.type,
  };

  return new Promise((resolve, reject) => {
    myBucket
      .putObject(params)
      .on("httpUploadProgress", (evt, response) => {
        // console.log(Math.round((evt.loaded / evt.total) * 100));
        // console.log(response);
      })
      .send((err, data) => {
        if (err) {
          console.log("main upload Image to S3 err", err);
          return reject(err);
        } else {
          console.log("main photo uploaded to s3 data:=====>", data);
          return resolve(data);
        }
      });
  });
}

interface ConfirmParams {
  actionTitle?: string,
  onConfirm: Function,
  onClose?: Function,
  isdelete?: boolean,
  content?: string,
  customizeTitle?: string
  noIcon?: boolean
  customizeOkText?: string
  customizeWidth?: number
}
// Confirm Modal
export const ADI_CONFIRM = ({ actionTitle, onConfirm, onClose, isdelete, content, customizeTitle, noIcon, customizeOkText, customizeWidth }: ConfirmParams) => {
  confirm({
    width: customizeWidth ? customizeWidth : 400,
    // title: customizeTitle ? customizeTitle : (isdelete ? `Are you sure to ${actionTitle} ?` : `Do you want to ${actionTitle} ?`),
    title: customizeTitle ? customizeTitle : 'Are you sure?',
    icon: noIcon ? null : <WarningFilled style={{ color: '#FF8800' }} />,
    // content: content ? content : isdelete && '(Action cannot be undone.)',
    content: content ? content : isdelete && 'You won’t be able to undo this action.',
    okText: customizeOkText ? customizeOkText : isdelete ? 'Yes, Delete' : "Confirm",
    cancelText: isdelete ? 'No, Cancel' : "Cancel",
    // okButtonProps: {
    //   style: {
    //     backgroundColor: "red !important",
    //     borderColor: "#FF8800",
    //   },
    // },
    onOk() {
      onConfirm();
    },
    onCancel() {
      onClose && onClose();
    },
  });
};






// Get country, state, city data
export const allCountries = Country.getAllCountries()
export const getCountryCodeByName = (countryName: string) => {
  const country = allCountries.find((country) => country.name === countryName)
  return country?.isoCode || ''
}
export const getStateCodeByName = (stateName: string, countryCode: string) => {
  const state = State.getStatesOfCountry(countryCode).find((state) => state.name === stateName)
  return state?.isoCode || ''
}
export const getStatesByCountryName = (countryName: string) => {
  const countryCode = getCountryCodeByName(countryName)
  const states = State.getStatesOfCountry(countryCode)  // list of state obj {name: 'state name', isoCode: 'state code'}
  return { states, countryCode }
}
export const getCitiesByState = (stateName: string, countryCode: string) => {
  const stateCode = getStateCodeByName(stateName, countryCode)
  const cities = City.getCitiesOfState(countryCode, stateCode)  // list of city obj {name: 'city name', isoCode: 'city code'}
  return cities
}

// Get country, state, city options for selector
export const CountryInfo = {
  getCountryOptions: () => {
    return allCountries.map((country) => ({ label: country.name, value: country.name }))
  },
  getStateOptions: (countryName: string) => {
    const { states } = getStatesByCountryName(countryName)
    return states.map((state) => ({ label: state.name, value: state.name }))
  },
  getCityOptions: (stateName: string, countryName: string) => {
    const { countryCode } = getStatesByCountryName(countryName)
    const cities = getCitiesByState(stateName, countryCode)
    return cities.map((city) => ({ label: city.name, value: city.name }))
  }
}


/**
 * @description: Function takes four argument, list as the source of options, placeholder is used for creating the fist empty value option, valueKey and lableKey are optional which used for extract the value and lable from the source array
 * @return array of SelectorOptions
 */
export const getSelectorOptions = (
  list: any[],
  placeholder: string = "Select",
  valueKey?: string,
  labelKey?: string
) => {

  const opts: SelectorOption[] = []

  // if placeholder is empty string, then do not generate the first option with empty value
  if (placeholder !== "") {
    opts.push({ label: placeholder, value: "" })

  }

  if (Array.isArray(list)) {
    list.map((item: any, idx: number) => {
      if (!labelKey && !valueKey) {
        opts.push({
          label: item,
          value: item,
        });
      } else if (!labelKey && valueKey) {
        opts.push({
          label: item[valueKey],
          value: item[valueKey],
        });
      } else if (labelKey && valueKey) {
        opts.push({
          label: item[labelKey],
          value: item[valueKey],
        });
      } else if (labelKey && !valueKey) {
        // console.log("only pass the value key, just return item ");
        opts.push({
          label: item[labelKey],
          value: item[labelKey],
        });
      }
    });
  }



  // console.log("only pass the value key, just return item ", opts);

  return opts;
};

export const getTableFilterOptions = (
  list: string[],

) => {

  const opts: TableFilterOption[] = []
  list.map((item: any, idx: number) => {
    opts.push({
      text: item,
      value: item,
    });

  });

  // console.log("only pass the value key, just return item ", opts);

  return opts;
};

/**
 * @description: Function takes filter object, get the url for api querystring, looks like ?aa=aa&bb=bb
 * @return string 
 */

export const getFilterSearchUrl = (filter: { [key: string]: string | null }) => {
  let searchUrl = ``
  const searchCondition: string[] = []

  const filterKeys = Object.keys(filter)

  filterKeys.forEach((item: string) => {
    if (filter[item] !== '' && filter[item] !== null) {
      searchCondition.push(`${item}=${filter[item]}`)
    }
  })

  if (searchCondition.length > 0) {
    searchCondition.map((item: string, index: number) => {
      searchUrl = searchUrl + `${index == 0 ? '?' : '&'}${item}`
    })
  }

  console.log('searchUrl', searchUrl)
  return searchUrl
}

/**
 * @description: Function takes 
 * customer_atribute_config object,
 * values object of the values of the attribute, 
 * fileValues object of the values of the document attribute, 
 * 
 * return the customer attribute object
 * 
 * parameters examples:
 * customer_attribute_config = {
 * str: [{'k1': {helper: 'helper text', required: true}}],
 * int: [...],
 * bool: [...],
 * datetime: [...],
 * doc:[...]
 * }
 * return result will be like
 * attributeObj = {
 * k1:"value" ,
 * k2: "value",
 * k3: "value",
 * k4: "value",
 * }
 * @return object 
 */

export const getCustomAttributeObj = (custom_attribute_config: any, values: any, fileValues: any) => {


  const attributeObj: { [key: string]: any } = {}

  // get the custom attributes values for str, int, bool, 
  if (custom_attribute_config.str && custom_attribute_config.str.length > 0) {

    custom_attribute_config.str.map((item: string) => {
      const key = Object.keys(item)[0]
      attributeObj[key] = values[key]
    })

  }
  if (custom_attribute_config.bool && custom_attribute_config.bool.length > 0) {

    custom_attribute_config.bool.forEach((item: string) => {
      const key = Object.keys(item)[0]
      attributeObj[key] = values[key]
    })

  }
  if (custom_attribute_config.int && custom_attribute_config.int.length > 0) {

    custom_attribute_config.int.forEach((item: string) => {
      const key = Object.keys(item)[0]
      attributeObj[key] = values[key]
    })

  }

  // get the custom attributes values for datetime 
  if (custom_attribute_config.datetime && custom_attribute_config.datetime.length > 0) {

    custom_attribute_config.datetime.forEach((item: string) => {
      const key = Object.keys(item)[0]
      // side modal is editing single asset, the value of this attribute will be a string
      if (typeof values[key] == 'string') {
        attributeObj[key] = moment(values[key])
      } else {
        // datetime will be the moment object in add single or bulk asset
        attributeObj[key] = convertDateAndTime(values[key])
      }

    })

  }

  // get the custom attributes values for doc 
  if (custom_attribute_config.doc && custom_attribute_config.doc.length > 0) {
    custom_attribute_config.doc.forEach((item: any) => {
      const key = Object.keys(item)[0]

      const fileVal = fileValues[key]
      // console.log('doc typeof', typeof item)
      if (typeof fileVal == 'string') {
        attributeObj[key] = fileValues[key]
      }

      else if (typeof fileVal == 'object') {
        attributeObj[key] = fileValues[key].name
      } else {
        // console.log('not a string or not an object')
      }
    })

    // else {
    //   if (isBulk) {
    //     custom_attribute_config.doc.forEach((item: string) => {
    //       // get the name for the file 
    //       console.log("doc curFile add single asset", attachDoc);
    //       attributeObj[item] = attachDoc[item].name
    //     })
    //   } else {
    //     custom_attribute_config.doc.forEach((item: string) => {
    //       // get the name for the file 
    //       console.log("doc curFile bulk", attachDoc);
    //       attributeObj[item] = attachDocBulk[item].name
    //     })
    //   }


    // }



  }

  // console.log("attributeObj result ==> ", attributeObj);

  return attributeObj

}

export const formatDateString = (dateStr: string) => {
  let result = 'No Date'
  if (dateStr.length > 0) {
    result = moment(new Date(dateStr)).format(DATE_FORMAT)
  }


  return result
}


export const validateURL = (url: string): boolean => {
  const regex = /^(?:https?:\/\/)?(?:www\.)?[a-zA-Z0-9]+\.[A-Za-z]{2,}(?:\/.*)?$/;
  return regex.test(url);
}


// combine CDN and s3 key to get the s3 url
export const constructS3Url = (s3Key: string) => {
  const cdn = process.env.REACT_APP_CDN
  return `${cdn}${s3Key}`
}

// combine YYYY-MM-DD and HH:mm:ss into YYYY-MM-DDTHH:mm:ss.sssZ
// date and time should be moment object
export const combineDateAndTime = (date: any, time: any) => {
  // return moment(moment(date).format('YYYY-MM-DD') + ' ' + moment(time).format('HH:mm:ss')).format('YYYY-MM-DDTHH:mm:ssZ')
  return convertDateAndTime(moment(moment(date).format('YYYY-MM-DD') + ' ' + moment(time).format('HH:mm:ss')), 'datetime')
}

// convert date format for db
// param date can be date string or moment object
export const convertDateAndTime = (date: any, type?: 'date' | 'time' | 'datetime' | 'datetimeOffset') => {
  if (!type) {
    return moment(date).toISOString()  // YYYY-MM-DDTHH:mm:ss.sssZ
  } else {
    switch (type) {
      case 'date':
        return moment(date).format('YYYY-MM-DD')
      case 'time':
        return moment(date).format('HH:mm:ss')
      case 'datetime':
        return moment(date).toISOString() // YYYY-MM-DDTHH:mm:ss.sssZ
      case 'datetimeOffset':
        return moment(date).format('YYYY-MM-DDTHH:mm:ss.SSSZ') // e.g. 2023-10-19T14:30:06.363+11:00
      default:
        return moment(date).toISOString()
    }

  }
}

// convert date url to a file object  
export const dataUrlToFile = (dataUrl: string, filename: string): File => {
  // Convert Data URL to Blob
  const byteString = atob(dataUrl.split(',')[1]);
  const mimeString = dataUrl.split(',')[0].split(':')[1].split(';')[0];
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  const blob = new Blob([ab], { type: mimeString });

  // Create new File object from Blob
  const file = new File([blob], filename, { type: mimeString });

  return file;
}

// this function will return an tabs array by taking a pre-defined tabs object
export const getTabsArrayFromTabsObj = (tabsObj: { [key: string]: any }) => {
  return Object.keys(tabsObj).map((item: string) => ({ key: tabsObj[item], label: tabsObj[item] }))
}

export const includeColumn = (selectedColumnList: any[], dataIndex: string) => {
  const result = selectedColumnList.some((item) => item == dataIndex)
  return result
}

// log errors
export const logError = (e: any) => {
  // console.log('Error: ')
  console.log("API error: ", e)
  if (e.response) console.log(e.response)
}

// check if the cursor has selected any text on the window
export const checkWindowSelectedText = () => {
  let text = '';
  if (window.getSelection) {
    text = window?.getSelection()?.toString() || '';
  }
  if (text.length > 0) {
    return true
  } else {
    return false
  }
}

// convert string boolean to boolean or boolean to string boolean
export const convertStrBool = (value: 'true' | 'false' | boolean, goal: 'bool' | 'str') => {
  if (goal === 'str') {
    return value.toString()
  } else if (goal === 'bool') {
    return value === 'true' ? true : false
  }
}

export const disabledDateBeforeTodayFunction = (current: any) => {
  return current && current < new Date().setHours(0, 0, 0, 0)
};

// Disable dates from the DatePicker Input
export const disablePastDates = (current: any) => {
  return current && current < moment().startOf("day");
};
export const disableFutureDates = (current: any) => {
  return current && current > moment().endOf("day");
};